import clsx from 'clsx';
import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Stack } from '../stack';
import classes from './confirmation-card.module.scss';

export type ConfirmationCardProps = PropsWithChildren & {
  /**
   * The icon prop is an optional prop that accepts a React node.
   * This prop is used to display an icon inside a component.
   */
  icon?: ReactNode;

  /**
   * The className variable represents the name of the CSS class associated with an element.
   */
  className?: string;

  /**
   * Customizable classes for the content
   */
  classes?: {
    content?: string;
  };

  /**
   * Determines whether elevation effects or shadow is applied to a component.
   * If set to true, elevation styling will be enabled; if false or undefined, it will be disabled.
   */
  elevation?: boolean;
};

export const ConfirmationCard: FC<ConfirmationCardProps> = ({
  icon,
  children,
  className,
  classes: customClasses,
  elevation = true,
}) => {
  return (
    <div className={clsx(classes.root, 'confirmation-card-component', className, { [classes.isElevated]: elevation })}>
      <Stack
        direction="column"
        crossAxis="center"
        spacing={4}
        className={clsx(customClasses?.content)}
      >
        {icon}
        {children}
      </Stack>
    </div>
  );
};
